import styled from 'styled-components';

export const LanguageModal = styled.div<{visible: boolean}>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100vh;
    z-index: 99;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.9);
    overflow: hidden;
    opacity: ${({ visible }) => (visible ? 1 : 0)};
    visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
    transition: opacity 0.3s ease, visibility 0.3s ease;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 15px;
    right: 15px;
    left: auto;
    width: 36px;
    height: 36px;
    background-color: #FFF;
    border-radius: 50%;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

export const LanguageContainer = styled.div`
    display: flex;
    height: 100%;
    padding-top: 92px;
    padding-bottom: 92px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
`;

export const Title = styled.span`
    font-size: 18px;
    line-height: 48px;
    font-weight: 500;
    color: #FFF;
`;

export const LanguageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    overflow-x: scroll;
    scrollbar-width: none;
    overflow: auto;
    max-height: 70vh;
`;

export const LangOption = styled.div<{active: boolean}>`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    background-color: #FFF;
    border-radius: 10px;
    padding: 0 15px;
    width: 320px;
    height: 50px;
    gap: 12px;
    background: ${({ active }) => (active ? '#aeabab' : '#000')};
    cursor: pointer;
`;

export const Flag = styled.div`
    width: 26px;
    height: 26px;  
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FlagContainer = styled.div`
    width: 30px;
    height: 30px;  
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LangButton = styled.button`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: none;
    overflow: hidden;
`;

export const Lang = styled.span<{ active: boolean }>`
    font-size: 14px;
    line-height: 1.2;
    font-weight: 500;
    color: ${({ active }) => (active ? '#1C1C1C' : '#FFF')};
`;

export const CheckIcon = styled.div`
    width: 18px;
    height: 18px;
    background: #000;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
`;

export const contryFlag = {
  width: '24px',
  height: '24px',
};

export const contryFlagLarge = {
  width: '100%',
  height: '100%',
  borderRadius: '100%',
  overflow: 'hidden',
  stroke: '1px',
};

export const FlagImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  overflow: hidden;
  stroke: 1px;
`;
